/* eslint-disable max-len */
// -----------------------------------------------------------------------------
export enum RecommendationConditions {
  ConditionCooldownFromOverwolfInstall = 'ConditionCooldownFromOverwolfInstall',
  ConditionCooldownFromLastNotification = 'ConditionCooldownFromLastNotification',
  ConditionOverwolfNotificationNotShown = 'ConditionOverwolfNotificationNotShown',
  ConditionGameNotRunning = 'ConditionGameNotRunning',
  ConditionDidntDownloadSpecificApplication = 'ConditionDidntDownloadSpecificApplication',
  ConditionGPUSupported = 'ConditionGPUSupported',
  ConditionGeoRestriction = 'ConditionGeoRestriction',
  ConditionNoInstalledDedicatedGameApplication = 'ConditionNoInstalledDedicatedGameApplication',
  ConditionOwEnabled = 'ConditionOwEnabled',
  ConditionElectronEnabled = 'ConditionElectronEnabled',
}
